<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      SegmentRevealRate(:item="item", @itemUpdated="$emit('itemUpdated')")
      ActionButton(:action="remove", :confirm="true") Delete

</template>

<script>
import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
import ModalReveal from '../../foundation/ModalReveal'
import ActionButton from '../ActionButton'
import CouponReveal from '../../../../pages/backoffice/CouponReveal'
import SegmentRevealRate from "../../../../pages/backoffice/SegmentRateReveal";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";

export default {
  name: 'SegmentButtons',
  components: {SegmentRevealRate, CouponReveal, PolicyReveal, ActionButton, ModalReveal},
  data() {
    return {}
  },
  created() {


  },

  methods: {
    remove() {
      return KeplerBackofficeSdk.segmentRates.select(this.item.id).remove(() => {
        this.$emit('itemUpdated')
      })
    }
  },

  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SegmentButtons.vue?c28c5f0c